// Magyar szállítási módok (bruttó díjak, HUF).
// FONTOS: a backend (base44/shared/shippingOptions.ts) ugyanezt a táblát használja — együtt módosítsd!

export const SHIPPING_OPTIONS = [
  {
    id: 'foxpost',
    label: 'Foxpost csomagautomata',
    description: '2–3 munkanap • 18 000 Ft felett ingyenes',
    feeHuf: 1190,
    freeOverHuf: 18000,
    needsPickupPoint: true,
  },
  {
    id: 'gls_locker',
    label: 'GLS csomagpont / automata',
    description: '2–3 munkanap',
    feeHuf: 1990,
    needsPickupPoint: true,
  },
  {
    id: 'gls',
    label: 'GLS házhozszállítás',
    description: '1–2 munkanap',
    feeHuf: 2390,
  },
  {
    id: 'local_pickup',
    label: 'Személyes átvétel Kecskeméten',
    description: 'Előzetes egyeztetés alapján',
    feeHuf: 0,
  },
];

// Régi név — más fájlok még hivatkozhatnak rá.
export const ROYAL_MAIL_OPTIONS = SHIPPING_OPTIONS;

export const DEFAULT_SHIPPING_OPTION = 'foxpost';

export function getShippingOption(id) {
  return SHIPPING_OPTIONS.find((o) => o.id === id) || SHIPPING_OPTIONS[0];
}

/** Tényleges szállítási díj a termékek bruttó összege alapján. */
export function shippingFeeFor(id, productsTotalHuf) {
  const opt = getShippingOption(id);
  if (opt.freeOverHuf && productsTotalHuf >= opt.freeOverHuf) return 0;
  return opt.feeHuf;
}